import React, { useEffect, useState } from 'react';
import { useInterval } from 'react-use';
import { convertDateToTimeZone, DateFormatter } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';

interface IProps {
  timezone: string;
}

const WeatherTime: React.FC<IProps> = ({ timezone }) => {
  const [time, setTime] = useState<string>('');

  const formatTime = () => {
    setTime(
      DateFormatter({
        format: DateFormats['h:mm a'],
        date: convertDateToTimeZone(new Date(), timezone),
      }),
    );
  };

  const delay = 60 * 1000;

  useInterval(() => {
    formatTime();
  }, delay);

  useEffect(() => {
    formatTime();
  }, [timezone]);

  return <>{time}</>;
};

export default WeatherTime;
